"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var icon_enum_1 = __importDefault(require("../../shared/enums/icon.enum"));
var priority_enum_1 = __importDefault(require("../../shared/enums/priority.enum"));
var style_enum_1 = __importDefault(require("../../shared/enums/style.enum"));
var VisualActionDefaults = {
    educator: {
        style: style_enum_1.default.ROUNDED
    },
    student_k_2: {
        size: "1:1",
        style: style_enum_1.default.CIRCLE,
        priority: priority_enum_1.default.PRIMARY,
        content: {
            className: "align-items-center text-center text-white",
            action: {
                priority: priority_enum_1.default.SUCCESS,
                style: style_enum_1.default.ROUNDED,
                text: "GO",
                className: "text-white mx-auto",
                icon: {
                    icon: icon_enum_1.default.ARROW_RIGHT,
                    className: "ms-1"
                }
            }
        }
    },
    student_3_5: {
        size: "1:1",
        style: style_enum_1.default.CIRCLE,
        priority: priority_enum_1.default.PRIMARY,
        content: {
            className: "align-items-center text-center text-white",
            action: {
                priority: priority_enum_1.default.SUCCESS,
                style: style_enum_1.default.ROUNDED,
                text: "GO",
                className: "text-white mx-auto",
                icon: {
                    icon: icon_enum_1.default.ARROW_RIGHT,
                    className: "ms-1"
                }
            }
        }
    },
    student_6_8: {
        style: style_enum_1.default.ROUNDED,
        priority: priority_enum_1.default.PRIMARY,
        className: "align-items-center text-center",
        content: {
            action: {
                priority: "link",
                text: "Let's Go!",
                icon: undefined,
                className: "text-white text-decoration-none"
            }
        }
    },
    student_9_12: {
        style: style_enum_1.default.ROUNDED,
        priority: undefined,
        bodyClassName: "p-0",
        content: {
            action: {
                priority: priority_enum_1.default.PRIMARY,
                text: "Let's Go!",
                icon: undefined,
                className: "mb-3"
            }
        }
    }
};
exports.default = VisualActionDefaults;
